exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-message[data-v-ab35b9de]{vertical-align:text-bottom}.title[data-v-ab35b9de]{min-height:40px;display:flex;align-items:center;font-weight:700}", ""]);

// exports
